import { Inject, Injectable, Optional } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
import { SeoSetupService } from '@b2b/seo-util-lib';

@Injectable({ providedIn: 'root' })
export class B2bRouterService {
  private _history: string[] = [];
  private _rootUrl!: string; // Default Fallback in case we do not have any navigation history
  private _fallbackPrefix!: string; // Always added in case of a Fallback (Useful when used within other libraries)

  constructor(
    private _router: Router,
    private _location: Location,
    @Optional() @Inject('WINDOW') private window: any,
    private analyticsEventService: AnalyticsEventService,
    private seoSetupService: SeoSetupService,
  ) {
    this._rootUrl = '/';
    this._fallbackPrefix = '';

    this._router.events
      .pipe(
        // filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        filter((event) => {
          if (event instanceof NavigationStart) {
            if (event?.url?.indexOf('page-not-found') > -1) {
              this.popHistory();
              // this.window.history.replaceState(null, '', record);
            }
            this.seoSetupService.resetSeoData();
          }
          if (event instanceof NavigationEnd) {
          }
          return event instanceof NavigationEnd;
        }),
        map((event: NavigationEnd) => {
          this.analyticsEventService.setScreenName(event?.urlAfterRedirects);
          return event;
        }),
      )
      .subscribe((event) => {
        this.setHistory(event.urlAfterRedirects);
        // this._history.push(event.urlAfterRedirects);
      });

    if (this._router?.url) {
      this.setHistory(this._router?.url);
    }
  }

  popHistory() {
    if (this._history?.length > 0) {
      return this._history.pop();
    }
    return undefined;
  }

  setHistory(url: string) {
    if (!this._history) {
      this._history = [];
    }
    this._history = this._history.filter((item: string) => {
      return item !== url;
    });
    if (
      url?.indexOf('page-not-found') > -1 ||
      url?.indexOf('feature/checkout/verify-transaction') > -1
    ) {
    } else {
      this._history.push(url);
    }
  }

  back(fallback?: string): void {
    fallback = this._fallbackPrefix + (fallback || this._rootUrl);

    const record = this.popHistory();

    if (this._history.length > 0) {
      if (this._history.length === 1) {
        const path = this._history[0];
        if (path === '/') {
          this._router.navigateByUrl('/').then();
          return;
        }
      }

      this._location.back();
    } else {
      if (this.window) {
        try {
          this.window.history.replaceState(null, '', fallback);
        } catch (e) {}
        try {
          this.window.history.pushState(null, '', record ?? this._router.url);
        } catch (e) {
          console.error('e ', e);
        }
        this._location.back();
      } else {
        this._router.navigateByUrl('/').then();
      }
    }
  }
}
